var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconExpert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 236,
    viewBox: "0 0 236 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.485 77.2272L211.248 82.1908L198.485 87.1543L193.521 99.9176L188.38 87.1543L175.794 82.1908L188.38 77.2272L193.521 64.4639L198.485 77.2272Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4393 131.473C58.4393 133.069 57.1984 134.31 55.603 134.31H54.3621C55.9575 134.31 57.1984 135.551 57.1984 137.146C57.1984 138.742 55.9575 139.982 54.3621 139.982H53.1211C54.7166 139.982 55.9575 141.223 55.9575 142.819C55.9575 144.414 54.7166 145.655 53.1211 145.655H51.8802C53.4757 145.655 54.7166 146.896 54.7166 148.491C54.7166 150.087 53.4757 151.328 51.8802 151.328H33.2666V130.41C33.2666 128.46 34.153 126.687 35.5711 125.446L38.053 123.319C38.9393 122.61 39.4711 121.369 39.4711 120.128V119.596C39.4711 118.001 40.7121 116.76 42.3075 116.76C43.903 116.76 45.1439 118.001 45.1439 119.596V121.546C45.1439 123.673 44.2575 125.801 42.8393 127.396L41.5984 128.637H55.9575C57.1984 128.814 58.4393 130.055 58.4393 131.473Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4424 127.396H27.0605V152.391H33.4424V127.396Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6589 99.9186C52.4494 99.9186 60.3862 91.982 60.3862 82.1917C60.3862 72.4014 52.4494 64.4648 42.6589 64.4648C32.8684 64.4648 24.9316 72.4014 24.9316 82.1917C24.9316 91.982 32.8684 99.9186 42.6589 99.9186Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8633 80.4185L41.0678 86.6234L55.0724 72.6182",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155.756 57.9053V66.237C155.579 66.0597 155.579 65.8825 155.402 65.8825C155.047 65.5279 154.87 65.3507 154.515 64.9961C152.92 63.7552 150.793 63.0461 148.665 63.0461H146.538C146.184 63.0461 145.829 63.0461 145.475 63.0461C145.12 63.0461 144.943 63.0461 144.765 63.0461C143.525 63.0461 142.284 62.6916 141.22 62.337C139.093 61.628 137.32 60.5643 135.902 59.1462C134.838 58.0825 134.129 57.0189 133.42 55.778C132.534 54.5371 132.002 53.1189 131.647 51.5235C130.761 58.0825 125.088 63.0461 118.175 63.0461H91.0519C90.6973 63.0461 90.3428 63.0461 89.9882 63.0461H87.6837C85.5564 63.0461 83.4291 63.7552 81.8337 64.9961C81.4791 65.3507 81.1246 65.5279 80.7701 65.8825C80.7701 65.8825 80.77 65.8825 80.5928 66.0598V57.9053C80.5928 37.1645 97.2564 20.501 117.997 20.501C139.093 20.501 155.756 37.1645 155.756 57.9053Z",
    fill: "#F6BE00",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M171.364 153.808V194.935H65V153.808C65 139.271 75.6364 126.685 89.9955 124.38L94.9591 123.494L100.1 145.476L109.318 141.044L118.182 136.79L127.045 141.044L136.264 145.476L141.405 123.494L146.368 124.38C160.727 126.685 171.364 139.094 171.364 153.808Z",
    fill: "#F6BE00",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.178 136.79L115.164 138.208L109.314 141.044L100.096 145.476L94.9551 123.494L104.882 121.722L118.178 136.79Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.404 123.494L136.263 145.476L127.045 141.044L121.195 138.208L118.182 136.79L131.477 121.722L141.404 123.494Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M155.756 57.9053V66.237C155.579 66.0597 155.579 65.8825 155.402 65.8825C155.047 65.5279 154.87 65.3507 154.515 64.9961C152.92 63.7552 150.793 63.0461 148.665 63.0461H146.538C146.184 63.0461 145.829 63.0461 145.475 63.0461C145.12 63.0461 144.943 63.0461 144.765 63.0461C143.525 63.0461 142.284 62.6916 141.22 62.337C139.093 61.628 137.32 60.5643 135.902 59.1462C134.838 58.0825 134.129 57.0189 133.42 55.778C132.534 54.5371 132.002 53.1189 131.647 51.5235C130.761 58.0825 125.088 63.0461 118.175 63.0461H91.0519C90.6973 63.0461 90.3428 63.0461 89.9882 63.0461H87.6837C85.5564 63.0461 83.4291 63.7552 81.8337 64.9961C81.4791 65.3507 81.1246 65.5279 80.7701 65.8825C80.7701 65.8825 80.77 65.8825 80.5928 66.0598V57.9053C80.5928 37.1645 97.2564 20.501 117.997 20.501C139.093 20.501 155.756 37.1645 155.756 57.9053Z",
    fill: "#F6BE00",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M171.364 153.808V194.935H65V153.808C65 139.271 75.6364 126.685 89.9955 124.38L94.9591 123.494L100.1 145.476L109.318 141.044L118.182 136.79L127.045 141.044L136.264 145.476L141.405 123.494L146.368 124.38C160.727 126.685 171.364 139.094 171.364 153.808Z",
    fill: "#8CA0C4",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M118.178 136.79L115.164 138.208L109.314 141.044L100.096 145.476L94.9551 123.494L104.882 121.722L118.178 136.79Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M141.404 123.494L136.263 145.476L127.045 141.044L121.195 138.208L118.182 136.79L131.477 121.722L141.404 123.494Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M91.586 63.0449V82.5445H87.8633C82.5451 82.5445 78.1133 78.1128 78.1133 72.7947C78.1133 70.1357 79.1769 67.8312 80.7724 66.0585C80.7724 66.0585 80.7724 66.0585 80.9496 65.8812C81.3042 65.5267 81.6587 65.3494 82.0133 64.9949C83.6087 63.754 85.736 63.0449 87.8633 63.0449H91.586Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M158.242 72.7947C158.242 78.1128 153.81 82.5445 148.492 82.5445H144.77V63.0449H148.492C150.797 63.0449 152.747 63.754 154.342 64.9949C154.697 65.3494 155.051 65.5267 155.229 65.8812C155.406 66.0585 155.406 66.2358 155.583 66.2358C157.356 68.0085 158.242 70.313 158.242 72.7947Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M114.097 235C97.2562 234.468 81.3017 230.391 67.1199 223.477C46.0244 213.196 28.4744 196.886 16.7744 176.5H66.4108C66.5881 177.386 66.9426 178.273 67.2972 179.336C70.3108 189.086 74.0335 197.95 78.4653 205.573C87.8608 222.414 100.27 233.405 114.097 235Z",
    fill: "#8CA0C4",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M219.04 176.5C212.836 187.491 204.681 197.241 195.463 205.395C187.486 212.486 178.445 218.514 168.695 223.3C154.336 230.214 138.204 234.291 121.186 234.823C135.013 233.227 147.599 222.414 157.172 205.395C161.604 197.418 165.504 188.2 168.695 177.918C168.872 177.386 169.049 177.032 169.049 176.5H219.04Z",
    fill: "#8CA0C4",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M169.052 176.499C168.875 177.03 168.698 177.385 168.698 177.917C165.507 188.199 161.784 197.594 157.175 205.394H78.1112C73.8566 197.771 70.1339 188.908 66.943 179.158C66.5885 178.271 66.4112 177.385 66.0566 176.321H169.052V176.499Z",
    fill: "#8CA0C4",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M157 205.395C147.25 222.413 134.841 233.226 121.013 234.821C119.95 234.821 118.886 234.821 117.822 234.821C116.581 234.821 115.341 234.821 114.1 234.821C100.272 233.226 87.8633 222.413 78.1133 205.395H157Z",
    fill: "#8CA0C4",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M195.468 205.395H195.291H157",
    fill: "#8CA0C4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M195.468 205.395H195.291H157",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1062 205.395H40.5244",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8773 21.5635C70.6682 8.62269 93.3591 1 118 1C182.527 1 235 53.2952 235 117.999C235 182.704 182.705 234.999 118 234.999C53.2955 234.999 1 182.704 1 117.999C1 92.295 9.33182 68.5406 23.3364 49.2179",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9086 17.1324V19.6142C46.9086 23.6914 45.3131 27.5914 42.2995 30.4277L40.8813 31.8459C39.9949 32.7322 39.4631 33.7958 39.4631 35.0367V36.4549H26.1676V35.214C26.1676 33.9731 25.6358 32.7322 24.7495 31.8459L23.3313 30.4277C20.3176 27.5914 18.5449 23.6914 18.5449 19.4369V16.9551C18.5449 9.15519 24.9267 2.77344 32.7267 2.77344C36.6267 2.95071 40.1722 4.54615 42.654 7.20521C45.3131 9.687 46.9086 13.2324 46.9086 17.1324Z",
    fill: "#F6BE00",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6568 39.8234C42.6568 40.7098 42.3023 41.5962 41.5932 42.128C41.0614 42.6598 40.175 43.0144 39.2886 43.0144H25.9932C24.2205 43.0144 22.625 41.5962 22.625 39.6461C22.625 38.7597 22.9795 37.8733 23.5114 37.3415C24.2205 36.8096 24.9295 36.4551 25.9932 36.4551H39.4659C41.2386 36.4551 42.6568 38.0506 42.6568 39.8234Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5527 25.6419L37.1618 21.0332",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M32.553 25.6419L27.7666 21.0332",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5527 36.455V25.6416",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M38.576 43.1914C38.2214 46.0278 35.7396 48.1551 32.726 48.1551C29.7123 48.1551 27.2305 46.0278 26.876 43.1914H38.576Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M197.248 134.309V144.945C196.893 144.945 196.361 144.767 196.007 144.767H190.866C190.511 144.767 189.98 144.767 189.625 144.945V134.309C190.334 134.486 191.22 134.663 192.107 134.663H194.766C195.652 134.663 196.361 134.486 197.248 134.309Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M203.628 152.389H183.419C183.419 150.262 184.305 148.489 185.546 147.071C186.61 146.007 188.028 145.298 189.623 144.944C189.978 144.944 190.51 144.767 190.864 144.767H196.005C196.36 144.767 196.892 144.767 197.246 144.944C200.792 145.476 203.628 148.667 203.628 152.389Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M185.544 131.827C179.871 130.409 175.794 125.445 175.794 119.418H183.239V125.8C183.239 128.104 184.126 130.232 185.544 131.827Z",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M211.068 119.418C211.068 125.445 206.991 130.409 201.318 131.65C202.737 130.054 203.623 128.104 203.623 125.8V119.418H211.068V119.418Z",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M203.624 116.936V125.8C203.624 128.104 202.737 130.054 201.319 131.65C200.255 132.891 198.837 133.777 197.242 134.132C196.533 134.309 195.646 134.486 194.76 134.486H192.101C191.215 134.486 190.505 134.309 189.619 134.132C188.024 133.777 186.605 132.713 185.542 131.65C184.124 130.054 183.237 128.104 183.237 125.8V116.936H203.624Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M144.771 62.8679V82.5453C144.771 92.2953 139.453 100.804 131.475 105.236C127.753 107.364 123.498 108.604 118.889 108.604H117.471C112.862 108.604 108.607 107.364 104.884 105.236C96.907 100.804 91.5889 92.2953 91.5889 82.5453V63.0452H118.357C125.271 63.0452 130.766 58.0816 131.83 51.5225C132.184 53.1179 132.716 54.5361 133.602 55.777C134.312 57.0179 135.021 58.0816 136.084 59.1452C137.502 60.5634 139.452 61.8043 141.403 62.3361C142.466 62.6907 143.53 62.8679 144.771 62.8679Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5889 63.0449V82.5445V63.0449Z",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M131.474 105.236V121.723L118.178 136.791L104.883 121.9V105.414C108.606 107.541 112.86 108.782 117.469 108.782H118.887C123.496 108.604 127.751 107.364 131.474 105.236Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpert);
export default __webpack_public_path__ + "static/media/icon-expert.2dee3a4fe316a0f9677a2d8b9a3a25d9.svg";
export { ForwardRef as ReactComponent };